export default "__VITE_ASSET__1f99ee04__"